var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZendeskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 14 14",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 6.5425,11.5475 -5.5425,0 5.5425,-6.6915 0,6.6915 z m 6.4575,0 -5.5425,0 c 0,-1.5315 1.2395,-2.7715 2.7715,-2.7715 1.5315,0 2.771,1.241 2.771,2.7715 z m -5.5425,-2.402 0,-6.693 5.5425,0 -5.5425,6.693 z M 6.5425,2.4525 C 6.5425,3.983 5.302,5.2245 3.771,5.2245 2.241,5.2245 1,3.984 1,2.4535 l 5.5425,0 0,-10e-4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendeskIcon);
export default __webpack_public_path__ + "static/media/zendesk-icon.3c1485cc331912258ab7214de021700c.svg";
export { ForwardRef as ReactComponent };